import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { ApproveQuoteModal } from './approve-quote';

export function initApproveQuote() {
  document.getElementsByName('approve-quote-modal').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ApproveQuoteModal {...props} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
